import { findConversation } from './findConversation';
import getFindConversationTraversal from './utils/getFindConversationTraversal';
import constant from 'owa-service/lib/factory/constant';
import fieldURIOrConstantType from 'owa-service/lib/factory/fieldURIOrConstantType';
import isEqualTo from 'owa-service/lib/factory/isEqualTo';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import restrictionType from 'owa-service/lib/factory/restrictionType';
import seekToConditionPageView from 'owa-service/lib/factory/seekToConditionPageView';
/**
 * The FindConversationWithSeekToCondition is based on the instance key of the last row present locally in the table.
 * This is currently used for load more scenario
 * @param folderId - The folderId for which we are fetching the data
 * @param instanceKey - We use instancekey of the last conversation we have in the loaded rows in the table.
 * @param rowsToLoad - the number of rows to load
 * @param viewFilter - view filter (e.g - Unread\Flag)
 * @param sortResults - sort by properties
 * @param findConversationShapeName - the shape for the request
 * @param options - optional parameters to be passed to request (method and/or headers)
 * @param categoryName - the cateogry name
 */
export function findConversationWithSeekToCondition(folderId, instanceKey, rowsToLoad, viewFilter, sortResults, focusedViewFilter, findConversationShapeName, options, categoryName) {
    var restriction = isEqualTo({
        FieldURIOrConstant: fieldURIOrConstantType({
            Item: constant({
                Value: instanceKey,
            }),
        }),
        Item: propertyUri({
            FieldURI: 'ConversationInstanceKey',
        }),
    });
    var seekToCondition = restrictionType({
        Item: restriction,
    });
    var paging = seekToConditionPageView({
        BasePoint: 'Beginning',
        Condition: seekToCondition,
        MaxEntriesReturned: rowsToLoad,
    });
    return findConversation(folderId, paging, viewFilter, sortResults, focusedViewFilter, findConversationShapeName, options, categoryName, getFindConversationTraversal(viewFilter)).then(function (response) {
        return response.json().then(function (json) { return json.Body; });
    });
}
//# sourceMappingURL=findConversationWithSeekToCondition.js.map